import { useLocation } from 'react-router-dom';

export const useKioskMode = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  return params.get('mode') === 'kiosk';
};
